// src/sections/BeschwerungSection.jsx
import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";

export default function BeschwerungSection({ selectedAnlageId }) {
  const options = ["Wannen", "Steine", "Kies", "andere"];

  const [checkedValues, setCheckedValues] = useState([]);

  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/beschwerung/anlage/${selectedAnlageId}`)
      .then((res) => {
        const data = res.data;
        const loaded = [];

        if (data.wannen) loaded.push("Wannen");
        if (data.steine) loaded.push("Steine");
        if (data.kies) loaded.push("Kies");
        if (data.andere) loaded.push("andere");

        setCheckedValues(loaded);
      })
      .catch(() => setCheckedValues([]));
  }, [selectedAnlageId]);

  const handleSave = async () => {
    const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      wannen: checked.includes("Wannen"),
      steine: checked.includes("Steine"),
      kies: checked.includes("Kies"),
      andere: checked.includes("andere"),
    };

    try {
      // try load existing
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/beschwerung/anlage/${selectedAnlageId}`
      );

      // update
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/beschwerung/${res.data.id}`,
        payload
      );

      showSuccess("Gespeichert", "Beschwerung wurde aktualisiert");
    } catch {
      // create
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/beschwerung`,
        payload
      );

      showSuccess("Gespeichert", "Beschwerung wurde gespeichert");
    }
  };

  return (
        <Box 
          p={8} 
          bg="white" 
          borderRadius="xl" 
          boxShadow="md" 
          mt={6} 
          mb={10} 
          maxW="fit-content"
        >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        BESCHWERUNG
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <input
              type="checkbox"
              value={opt}
              checked={checkedValues.includes(opt)}
              onChange={(e) =>
                setCheckedValues((prev) =>
                  e.target.checked
                    ? [...prev, opt]
                    : prev.filter((v) => v !== opt)
                )
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
        bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Beschwerung
      </Button>
    </Box>
  );
}